import { useLocation } from "react-router-dom";
import { formatPrice } from "../../../../utilities/formatPrice";

const MinimalPrice = ({ productInfo, currentVariation, currency }) => {
  const { product, attributes } = productInfo?.data;
  const { promotionalPriceUnique, priceUnique, percentExtraCoin } = product;

  const locationUrl = useLocation();

  const isFringeBenefitsPage = locationUrl?.pathname?.toLowerCase()?.includes("fringe");

  const cashback = percentExtraCoin / 100;

  if (!isFringeBenefitsPage || !(attributes?.length === 0 || currentVariation)) return null;

  return (
    <div className="text-green-500 text-sm m-0">
      Cashback:{" "}
      <span className="text-green-500 p-0 font-bold">
        {attributes.length === 0 ? (
          <>
            {promotionalPriceUnique ? (
              <>
                {currency} {formatPrice(promotionalPriceUnique * cashback)}
              </>
            ) : (
              <>
                {currency} {formatPrice(priceUnique * cashback)}
              </>
            )}
          </>
        ) : (
          <>
            {currency} {formatPrice(currentVariation.price * cashback)}
          </>
        )}
      </span>
    </div>
  );
};

export default MinimalPrice;
